import React, { ReactElement } from "react";
//#region types
import { CustomFormFieldsProps, FormFieldProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
//#endregion

function CustomFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, handleOnChangeCustom, handleOnBlurCustom, value, readonly } = props;
  const getCustomField = (CustomField: ReactElement) => {
    const extraProps = field.extraProps as CustomFormFieldsProps;

    return (
      // eslint-disable-next-line react/jsx-pascal-case -- since get the type from the Component passed to CustomerField which would satisfy the conditions
      <CustomField.type
        key={name}
        {...CustomField.props}
        {...extraProps}
        {...props}
        value={value}
        onChange={handleOnChangeCustom.bind(null, name)}
        onBlur={handleOnBlurCustom.bind(null, name)}
        isReadOnly={readonly}
      />
    );
  };

  return field.customField ? getCustomField(field.customField) : <React.Fragment />;
}

export default CustomFormField;
